<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}
.image_right {
  padding-bottom: 40px;
}




</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Magiun</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Hybrid publication, web development, illustration, food writing</p>
        <p>
          Magiun is a magazine about everyday food. It publishes stories, poems, essays, recipes, photos and illustrations.</p>
        <p>
          The <a href="https://magiun.alicestrete.me/firstissue">first edition</a> deals with eating in isolation - the struggles, the joys, the unexpected discoveries, the newly added anxieties. It came about as a desire to talk about our ever changing relationship to food, and how unexpected external factors (such as a global quarantine) can bring out new ways of relating to what we grow, buy, eat and share.</p>
          <p>The print publication was developed in collaboration with Simon Browne.</p>




      </div>
      </b-col>
      <b-col md="8">
        <b-row class="image_right">
          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/magiun/magiun_line_small.JPG"></b-img>

          </b-col>
        </b-row>
        <b-row class="image_right">

          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/magiun/magiun_shadow_small.JPG"></b-img>

          </b-col>
        </b-row>
        <b-row class="image_right">
      <b-col md="8" offset-md="2">
        <b-img class="img-fluid" src="media/magiun/magiun_simon.png"></b-img>

      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" offset-md="2">
      <b-img class="img-fluid" src="media/magiun/magiun_tash.png"></b-img>

      </b-col>
    </b-row>
    </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'Magiun',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
